import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ExternalRedirect = () => {
  const { module } = useParams();
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const routes = {
  "server-health": `${BASE_URL}api/server-health/dashboard/?token=`,
  "alert-stats": `${BASE_URL}api/alert-stats/dashboard/?token=`,
  "device-inspector": `${BASE_URL}api/device-inspector/dashboard/?token=`,
  "packet-validator": `${BASE_URL}api/packet-validator/dashboard/?token=`,
};

  useEffect(() => {
    if (routes[module]) {
      window.open(routes[module], "_blank", "noopener,noreferrer");
    }

    navigate("/dashboard", { replace: true });
  }, [module, navigate]);

  return null;
};

export default ExternalRedirect;